import { ActionMenu } from './ActionMenu';
import { AgentBadge } from './AgentBadge';
import { Attachments } from './Attachments';
import { Content } from './Content';
import { DateDivider } from './DateDivider';
import { EditedIndicator } from './EditedIndicator';
import { FromPill } from './FromPill';
import { HoverActions } from './HoverActions';
import { Layout } from './Layout';
import { MediaPreview } from './MediaPreview';
import { MessageFlag } from './MessageFlag';
import { NewDivider } from './NewDivider';
import { Reactions } from './Reactions';
import { Root } from './Root';
import { SenderIcon } from './SenderIcon';
import { MessageSenderName } from './SenderName';
import { Slot } from './Slot';
import { Timestamp } from './Timestamp';

export const Message = {
  Root,
  Layout,
  Slot,
  SenderName: MessageSenderName,
  AgentBadge,
  FromPill,
  SenderIcon,
  Timestamp,
  Content,
  Attachments,
  DateDivider,
  NewDivider,
  Reactions,
  EditedIndicator,
  HoverActions,
  MessageFlag,
  ActionMenu,
  MediaPreview,
};
